import React from 'react';
import {Link} from 'react-router-dom';
import {Article} from '../../types';
import {articleImage} from '../../utils/articleImage';
import {formatDate} from '../../utils/date';
import {articlePath} from '../../utils/slug';

interface NewsHoverItemProps {
    article: Article;
    /** the first image is usually the largest element on the page, so the browser should load it first */
    priority?: boolean;
}

const NewsHoverItem = ({article, priority = false}: NewsHoverItemProps) => (
    <Link to={articlePath(article)} className="hero-item">
        {/* React 18 doesn't know fetchPriority yet, the lowercase attribute is passed through */}
        <img className="hero-image" src={articleImage(article)} alt="" {...(priority ? {fetchpriority: 'high'} : {})}/>
        <div className="hero-content">
            <time className="hero-date" dateTime={article.date}>{formatDate(new Date(article.date))}</time>
            <h3 className="hero-title">{article.title}</h3>
            <p className="hero-excerpt">{article.excerpt}</p>
            <span className="hero-more">Weiterlesen →</span>
        </div>
    </Link>
);

export default NewsHoverItem;
